module.exports = __webpack_public_path__ + "static/template_options_calendar_columns-3e70356d6b76aefd339f6d02067df7e9.png";